import { usePapaParse } from 'react-papaparse';

export function CSVFormAdapter(
  CSVData,
  setCSVFile,
  eventSlug,
  handlefeedback,
  setMalformedCSV
) {
  const { jsonToCSV } = usePapaParse();

  const jsonData = handleBuildCSV(CSVData);

  if (jsonData.errors.length > 0) {
    const { errors } = jsonData;

    if (errors.includes('missing-mandatory-cols')) {
      handlefeedback(
        'danger',
        ["Column headers must include: 'First Name', 'Last Name', 'Email'"],
        'csv'
      );
      setMalformedCSV(true);
      return;
    }

    if (errors.includes('linkedin-error')) {
      handlefeedback(
        'warning',
        ['One or more LinkedIn URLs is incorrect. You may still send invites.'],
        'csv'
      );
    }
  }

  setMalformedCSV(false);
  const results = jsonToCSV(jsonData.csv);
  const file = new File([results], `${eventSlug + Date.now()}`, {
    type: 'text/csv',
  });

  setCSVFile(file);
}

export function getIndicesOfHeader(userAssignedHeaders) {
  return userAssignedHeaders.reduce((indices, col, idx) => {
    const testCase = col.toLowerCase().trim();

    const simpleTests = ['first', 'last', 'email', 'title', 'linkedin', 'industry']

    simpleTests.forEach(test => {
      if (testCase.includes(test)) {
        indices[`${test}Idx`] = idx;
        return indices;
      }
    })

    if (testCase === 'company') {
      indices.companyIdx = idx;
      return indices;
    }

    if (testCase === 'company url') {
      indices.companyUrlIdx = idx;
      return indices;
    }

    indices.malformed =
      !indices.hasOwnProperty('emailIdx') ||
      !indices.hasOwnProperty('firstIdx') ||
      !indices.hasOwnProperty('lastIdx');
    return indices;
  }, {});
}

export function skipUselessRow(row) {
  return row.every((val) => ['', undefined].includes(val));
}

export function buildCSV(templateHeaders, data, indices) {
  const csv = [templateHeaders];
  const { firstIdx, lastIdx, emailIdx, titleIdx, companyIdx, companyUrlIdx, linkedinIdx, industryIdx } = indices;
  const errors = [];

  for (let rowIdx = 0; rowIdx < data.length; rowIdx++) {
    const row = data[rowIdx];
    if (skipUselessRow(row)) continue;

    const rowData = [row[firstIdx].trim(), row[lastIdx].trim(), row[emailIdx].trim()];

    if (titleIdx) {
      rowData.push(row[titleIdx].trim() || 'missing-attribute-title');
    } else {
      rowData.push('missing-attribute-title');
    }

    if (companyIdx) {
      rowData.push(row[companyIdx].trim() || 'missing-attribute-company');
    } else {
      rowData.push('missing-attribute-company');
    }

    if (companyUrlIdx) {
      rowData.push(row[companyUrlIdx].trim() || null);
    } else {
      rowData.push(null)
    }

    if (linkedinIdx) {
      const linkedinUrl = row[linkedinIdx].trim();

      if (!linkedinUrl) {
        rowData.push(null);
      } else if (isValidLinkedinUrl(linkedinUrl)) {
        rowData.push(linkedinUrl);
      } else {
        rowData.push(null);
        errors.push('linkedin-error')
      }
    } else {
      rowData.push(null)
    }

    if (industryIdx) {
      rowData.push(row[industryIdx].trim() || null);
    } else {
      rowData.push(null)
    }

    csv.push(rowData);
  }

  return {csv, errors};
}

export function handleBuildCSV(CSVData) {
  const templateHeaders = [
    'First Name',
    'Last Name',
    'Email',
    'Title',
    'Company',
    'Company URL',
    'Linkedin URL',
    'Industry'
  ];

  const CSVDataHeaderRow = CSVData[0];
  const CSVDataMinusHeaderRow = CSVData.slice(1);
  const indices = getIndicesOfHeader(CSVDataHeaderRow);

  if (indices.malformed) {
    return { errors: ['missing-mandatory-cols'] }
  }

  const { csv, errors } = buildCSV(templateHeaders, CSVDataMinusHeaderRow, indices);

  console.log(csv);
  return { csv, errors };
}

export const downloadCSVTemplate = () => {
  const csv = 'First Name,Last Name,Email,Title,Company,Company URL,LinkedIn URL,Industry\n';
  let blob = new Blob([csv], { type: 'text/csv;encoding:utf-8' });
  let link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = 'external_invite_template';
  link.click();
  window.URL.revokeObjectURL(link.href);
}

export const isValidLinkedinUrl = (url) => {
  return /(https?:\/\/(www.)|(www.))?linkedin.com\/(mwlite\/|m\/)?in\/[a-zA-Z0-9_.-]+\/?/.test(url);
};
